(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Button", [], factory);
	else if(typeof exports === 'object')
		exports["Button"] = factory();
	else
		root["Button"] = factory();
})(this, function() {
return 